import React, { useContext, useEffect, useState } from 'react'
import { Grid, TextField, FormHelperText, MenuItem } from '@material-ui/core'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
import { Controller } from 'react-hook-form'
import AuthContext from './../../authContext'
import { numberWithCommas } from './../../utils/helpers'
import classes from './../../pages/createOrder/index.module.scss'
import JalaliUtils from '@date-io/jalaali'
import env from 'client-sdk/src/enviroments/enviroment'
import RonadIcons from '../iconComponent'
import { isWeekendDay } from '../../utils/Date/dayMethods'
import fillmentTypes from 'client-sdk/src/orders/getFulfillmentTypes'
import shippingDefinitions from 'client-sdk/src/orders/shippingDefinitions'
import handleError from '../../utils/handleError'
import { FillmentTypesProps } from './types'
import moment from 'moment'
import { convertDatePersianToEnglish } from '../../utils/helpers'
import { useCutoffHandler } from '../../utils/hook/useGetCutoffList'

function OrderInputs(props: any) {
  moment.locale('en')
  const date = new Date()
  const formattedDate = moment(date).format('YYYY-MM-DD')
  const authContext = useContext(AuthContext)
  const [isDisabledDeliveryService, setIsDisabledDeliveryService] =
    useState(false)

  const {
    form,
    setFulfillmentTypes,
    SetExtraLabelRequired,
    setCheckFilesRequired,
    setLoadReceiverInfo,
    setLocatedInTehran,
    SetAddressDisabled,
    setFormFieldsId,
    setContactsCourier,
    setDeliveryTime,
    setDataShipping,
    orderValue,
    setOrderValue,
    setCost,
    editMode,
    cost
  } = props
  const { errors, setValue, getValues, control, watch } = form
  const values = getValues()
  const [originOptions, setOriginOptions] = useState<any>([])
  const [stateFillmentTypes, setStateFillmentTypes] = useState<any>([])
  const [shippingdefinitions, setshippingdefinitions] = useState<any>([])
  const [curierDTOList, setCurierDTOList] = useState<any>([])
  const [visibleBillAmount, setVisibleBillAmount] = useState(false)
  const [firstCourierId, setFirstCourierId] = useState()
  const [dateInDatePiker, setDateInDatePiker] = useState<any>('')
  const [firstFulfillmentTypeId, setFirstFulfillmentTypeId] = useState()

  useEffect(() => {
    setOriginOptions(env.warehouses)
    setValue('origin', env.destinationId)
  }, [])

  const fulfillmentTypeId = watch('fulfillmentTypeId')
  const courierId = watch('courierId')
  const deliveryServiceId = watch('deliveryServiceId')
  const deliveryDate = watch('deliveryDate')
  const cutoffId = watch('cutoffId')

  const formattedDateSelected = moment(deliveryDate).format('YYYY-MM-DD')
  const dateSelected = convertDatePersianToEnglish(formattedDateSelected)

  const { listCutoff } = useCutoffHandler({
    courierId,
    dateSelected,
    fulfillmentTypeId,
    setDateInDatePiker,
    setValue,
    editMode: editMode
  })

  useEffect(() => {
    setFormFieldsId({
      fulfillmentTypeId: fulfillmentTypeId,
      courierId: courierId,
      deliveryServiceId: deliveryServiceId,
      cutoffId: cutoffId
    })
  }, [courierId, cutoffId])

  useEffect(() => {
    editMode || setValue('deliveryDate', formattedDate)
    setDateInDatePiker(formattedDate)
    const fetchFillmentTypes = async () => {
      try {
        const { res, ok } = await fillmentTypes('order')
        if (ok) setStateFillmentTypes(res)
      } catch (error) {
        handleError(error)
      }
    }
    fetchFillmentTypes()
  }, [])

  useEffect(() => {
    if (
      values.fulfillmentTypeId &&
      typeof values.fulfillmentTypeId === 'number'
    ) {
      setFirstFulfillmentTypeId(fulfillmentTypeId)
      const fetchShippingDefinitions = async () => {
        try {
          const { res, ok } = await shippingDefinitions(
            values.fulfillmentTypeId
          )
          if (ok) setshippingdefinitions(res.shippingDefinitionList)
        } catch (error) {
          handleError(error)
        }
      }
      fetchShippingDefinitions()
    }
    editMode || setValue('deliveryDate', formattedDate)
  }, [values.fulfillmentTypeId])

  useEffect(() => {
    const selectedFulfillmentType = stateFillmentTypes.find(
      (item: FillmentTypesProps) => item.id === fulfillmentTypeId
    )
    if (selectedFulfillmentType) {
      SetExtraLabelRequired(selectedFulfillmentType.extraLabelRequired)
      setCheckFilesRequired(selectedFulfillmentType.checkOrderFilesRequired)
      setIsDisabledDeliveryService(
        selectedFulfillmentType.deliveryServiceDisabled
      )
      if (selectedFulfillmentType.next) {
        const fulfillmentTypeNext = stateFillmentTypes.find(
          (item: FillmentTypesProps) => item.id == selectedFulfillmentType.next
        )
        setFulfillmentTypes({ selectedFulfillmentType, fulfillmentTypeNext })
      } else {
        setFulfillmentTypes({
          selectedFulfillmentType: null,
          fulfillmentTypeNext: null
        })
      }
    }
  }, [fulfillmentTypeId, stateFillmentTypes])

  useEffect(() => {
    const getCourierList = () => {
      if (shippingdefinitions.length === 1) {
        setFirstCourierId(courierId)
        const ress = shippingdefinitions.flatMap(
          (item: any) => item.deliveryServiceDTO
        )
        setValue('deliveryServiceId', ress[0]?.id)
        return ress[0]
      } else {
        const selectedDefinition = shippingdefinitions.find(
          (item: any) => item.deliveryServiceDTO.id === deliveryServiceId
        )
        return selectedDefinition ? selectedDefinition.deliveryServiceDTO : []
      }
    }
    const courierList = getCourierList()
    setCurierDTOList(courierList.courierDTOList)
  }, [deliveryServiceId, shippingdefinitions, courierId])

  useEffect(() => {
    if (curierDTOList) {
      const courier = curierDTOList.find((item: any) => item.id === courierId)
      if (courier) {
        if (courier.contacts && courier.contacts.length > 0) {
          setContactsCourier(courier.contacts)
          setLoadReceiverInfo(true)
        } else {
          setContactsCourier([])
          setLoadReceiverInfo(true)
        }
      } else {
        setContactsCourier([])
      }
    }
  }, [courierId, curierDTOList])

  useEffect(() => {
    handleCourierChange()
    if (curierDTOList) {
      const res = curierDTOList.find((item: any) => item.id === courierId)
      setVisibleBillAmount(res?.visibleBillAmount ?? false)
      setLocatedInTehran(res?.locatedInTehran ?? false)
      SetAddressDisabled(res?.addressDisabled ?? false)
    }
  }, [curierDTOList, courierId])

  const handleCourierChange = () => {
    const selectedCourier = curierDTOList?.find(
      (item: any) => item.id === courierId
    )
    if (selectedCourier) {
      setDataShipping({
        orderDeliveryTypeDTO: selectedCourier.orderDeliveryTypeDTO,
        fulfillmentLineDTO: selectedCourier.fulfillmentLineDTO,
        orderDeliveryLocationTypeDTO:
          selectedCourier.orderDeliveryLocationTypeDTO,
        orderPaymentTypeDTO: selectedCourier.orderPaymentTypeDTO,
        orderTPLTypeDTO: selectedCourier.orderTPLTypeDTO.name,
        postPaid: selectedCourier.postPaid
      })
    }
  }

  useEffect(() => {
    if (listCutoff.length > 0) {
      const rse = listCutoff.find((item: any) => item.id === cutoffId)
      setDeliveryTime(rse?.value)
      if (!rse) setValue('cutoffId', '')
    }
  }, [listCutoff, cutoffId])

  const handlerDisabledCourier = () => {
    const isFleetFieldEnabled =
      fulfillmentTypeId !== null &&
      (deliveryServiceId === 1 ||
        (deliveryServiceId !== 1 && deliveryServiceId !== null))
    return !isFleetFieldEnabled
  }

  useEffect(() => {
    if (firstCourierId && courierId && firstCourierId !== courierId) {
      setValue('cutoffId', '')
    }
  }, [courierId, firstCourierId])

  useEffect(() => {
    if (
      firstFulfillmentTypeId &&
      fulfillmentTypeId &&
      fulfillmentTypeId !== firstFulfillmentTypeId
    ) {
      setValue('cutoffId', '')
      setValue('courierId', '')
    }
  }, [fulfillmentTypeId, firstFulfillmentTypeId])

  return (
    <Grid container item md={8} spacing={3} style={{ margin: 0 }}>
      <Grid item lg>
        <div className={classes.item}>
          <div style={{ width: '100%' }}>
            <Controller
              name='trackingCode'
              label='* کد پیگیری'
              control={control}
              rules={{
                required: true,
                pattern: /^[A-Za-z\d\-_]+$/,
                minLength: 3
              }}
              as={
                <TextField
                  type='search'
                  variant='outlined'
                  fullWidth
                  id='trackingCode'
                  name='trackingCode'
                  error={!!errors.trackingCode && !!errors.trackingCode}
                  InputProps={{
                    endAdornment: (
                      <RonadIcons
                        name='information'
                        className='text-primary'
                        size={0.8}
                        title='کد دلخواه و منحصر به فرد برای هر سفارش که می‌توانید از طریق آن سفارش خود را در مراحل مختلف پیگیری نمایید'
                      />
                    )
                  }}
                />
              }
            />
            <FormHelperText error focused>
              {errors?.trackingCode?.type === 'required' &&
                'کدپیگیری الزامی میباشد'}
            </FormHelperText>
            <FormHelperText error focused>
              {errors?.trackingCode?.type === 'minLength' &&
                'کد پیگیری حداقل 3 کاراکتر می باشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item lg alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='fulfillmentTypeId'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='fulfillmentTypeId'
              id='fulfillmentTypeId'
              label='* نوع پردازش '
              rules={{
                required: true
              }}
              as={
                <TextField
                  type='search'
                  variant='outlined'
                  select
                  fullWidth
                  InputLabelProps={{
                    shrink: fulfillmentTypeId
                  }}
                  error={errors.fulfillmentTypeId && true}
                >
                  {stateFillmentTypes.map((item: FillmentTypesProps) => (
                    <MenuItem key={item.id} data-cy={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors?.fulfillmentTypeId && 'نوع سفارش الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item lg alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='deliveryServiceId'>
            <Controller
              style={{ width: '100%' }}
              rules={{
                required: true
              }}
              control={control}
              name='deliveryServiceId'
              id='deliveryServiceId'
              label='خدمات تحویل'
              as={
                <TextField
                  disabled={
                    isDisabledDeliveryService || fulfillmentTypeId === null
                  }
                  type='search'
                  variant='outlined'
                  select
                  fullWidth
                  InputLabelProps={{
                    shrink: deliveryServiceId
                  }}
                  error={errors.deliveryServiceId && true}
                >
                  {shippingdefinitions?.map((item: any, index: number) => (
                    <MenuItem
                      key={index}
                      data-cy={item.deliveryServiceDTO.id}
                      value={item.deliveryServiceDTO.id}
                    >
                      {item.deliveryServiceDTO.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors?.deliveryServiceId && ' خدمات تحویل الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      <Grid item lg alignItems='flex-end'>
        <div className={classes.item}>
          <div style={{ width: '100%' }} data-cy='courierId'>
            <Controller
              style={{ width: '100%' }}
              control={control}
              name='courierId'
              id='courierId'
              label='* ناوگان حمل'
              rules={{
                required: true
              }}
              as={
                <TextField
                  style={{ width: '100%' }}
                  type='search'
                  variant='outlined'
                  select
                  InputLabelProps={{
                    shrink: courierId
                  }}
                  fullWidth
                  disabled={handlerDisabledCourier()}
                  error={errors.courierId && true}
                >
                  {curierDTOList?.map((item: any) => (
                    <MenuItem key={item.id} data-cy={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
            />
            <FormHelperText error focused>
              {errors?.courierId && 'ناوگان حمل الزامی میباشد'}
            </FormHelperText>
          </div>
        </div>
      </Grid>

      {['65', '2', '119'].includes(authContext?.user?.partnerId) && (
        <Grid item lg>
          <div className={classes.item}>
            <div style={{ width: '100%' }} data-cy='startPoint'>
              <Controller
                style={{ width: '100%' }}
                control={control}
                name='origin'
                id='origin'
                label='انبار مبدا'
                rules={{
                  required: true
                }}
                as={
                  <TextField
                    select
                    fullWidth
                    variant='outlined'
                    style={{ width: '100%' }}
                    disabled={values.fulfillmentTypeId == ''}
                    error={errors.origin && true}
                  >
                    {authContext.user.partnerId == '14' && (
                      <MenuItem data-cy={'start' + 696} key='696' value='696'>
                        انبار داخلی
                      </MenuItem>
                    )}
                    {originOptions?.length > 0 ? (
                      originOptions.map((item: any, i: number) => (
                        <MenuItem
                          data-cy={'start' + i}
                          key={item.id}
                          value={item.id}
                        >
                          {item.name}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value=''>در حال بارگزاری</MenuItem>
                    )}
                  </TextField>
                }
              />
              <FormHelperText error focused>
                {errors.origin && 'مبدا سفارش الزامی میباشد'}
              </FormHelperText>
            </div>
          </div>
        </Grid>
      )}

      <Grid item lg={12}></Grid>
      <Grid item xs={12} sm={6} md={3} lg>
        <MuiPickersUtilsProvider utils={JalaliUtils} locale='fa'>
          <Controller
            rules={{ required: true }}
            name='deliveryDate'
            id='deliveryDate'
            control={control}
            as={
              <DatePicker
                inputVariant='outlined'
                id='deliveryDate'
                name='deliveryDate'
                label='* تاریخ تحویل سفارش'
                minDate={dateInDatePiker}
                format='jYYYY/jMM/jDD'
                shouldDisableDate={(d: any) => isWeekendDay(d?._d)}
                fullWidth
                disablePast
                autoOk
                okLabel='تأیید'
                cancelLabel='لغو'
                value={dateInDatePiker}
                defaultValue={null}
                disabled={values.fulfillmentTypeId == ''}
                error={errors.hasOwnProperty('deliveryDate')}
                helperText={errors.deliveryDate && errors.deliveryDate.message}
              />
            }
          />
          <FormHelperText error focused>
            {errors.deliveryDate && 'تاریخ تحویل سفارش الزامی میباشد'}
          </FormHelperText>
        </MuiPickersUtilsProvider>
      </Grid>

      <Grid item xs={12} sm={6} md={3} lg>
        <Controller
          rules={{ required: true }}
          style={{ width: '100%' }}
          control={control}
          name='cutoffId'
          id='cutoffId'
          label='* بازه تحویل سفارش'
          as={
            <TextField
              variant='outlined'
              select
              fullWidth
              label='* بازه تحویل سفارش'
              disabled={courierId === null || courierId === ''}
              error={!!errors.cutoffId}
              InputLabelProps={{
                shrink: cutoffId
              }}
            >
              {listCutoff.map((item: any) => (
                <MenuItem
                  disabled={!item.disableCutoff}
                  key={item.id}
                  value={item.id}
                  id={item.id}
                >
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          }
        />
        <FormHelperText error focused>
          {errors?.cutoffId && ' بازه تحویل سفارش الزامی میباشد'}
        </FormHelperText>
      </Grid>

      <Grid item xs={12} sm={4} md={3} lg>
        <TextField
          type='search'
          variant='outlined'
          fullWidth
          disabled={values.fulfillmentTypeId == ''}
          id='orderValue'
          name='orderValue'
          label='ارزش سفارش (ریال)'
          value={numberWithCommas(orderValue)}
          error={!!errors.orderValue && !!errors.orderValue}
          InputLabelProps={{
            shrink: numberWithCommas(orderValue)
          }}
          onChange={(e) => setOrderValue(e.target.value.replace(/,/g, ''))}
          InputProps={{
            endAdornment: (
              <RonadIcons
                name='information'
                className='text-primary'
                size={0.8}
                title='مقدار وارد شده به عنوان ارزش سفارش جهت بیمه ارسال اعمال میگردد'
              />
            )
          }}
        />
        <FormHelperText error focused>
          {errors.orderValue?.type === 'required' && 'ارزش سفارش الزامی میباشد'}
        </FormHelperText>
        <FormHelperText error focused>
          {errors?.orderValue?.type === 'validate' &&
            'لطفا عدد انگلیسی وارد کنید'}
        </FormHelperText>
      </Grid>
      {visibleBillAmount && (
        <Grid item xs={12} md={3} lg>
          <TextField
            type='text'
            variant='outlined'
            fullWidth
            id='cost'
            name='cost'
            label='مبلغ فاکتور (ریال)'
            value={numberWithCommas(cost)}
            error={!!errors.cost && !!errors.cost}
            onChange={(e) => setCost(e.target.value.replace(/,/g, ''))}
            InputProps={{
              endAdornment: (
                <RonadIcons
                  name='information'
                  className='text-primary'
                  size={0.8}
                  title='مقدار وارد شده به عنوان مبلغ نهایی از گیرنده سفارش دریافت میگردد'
                />
              )
            }}
          />
          <FormHelperText error focused>
            {errors?.cost?.type === 'required' && 'مبلغ فاکتور الزامی میباشد'}
          </FormHelperText>
          <FormHelperText error focused>
            {errors.cost?.type === 'validate' && 'لطفا عدد انگلیسی وارد کنید'}
          </FormHelperText>
        </Grid>
      )}
    </Grid>
  )
}
export default OrderInputs
